// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1LCkX","log":"ModalInventoryLogs_log__2Qxui","date":"ModalInventoryLogs_date__2InFP","userName":"ModalInventoryLogs_userName__1JIDN"};